import { RadioButton } from '@components/library/radio_button_group';

export enum WatermarkPositionsEnum {
    SouthWestGravity = 'SouthWestGravity',
    NorthWestGravity = 'NorthWestGravity',
    SouthEastGravity = 'SouthEastGravity',
    NorthEastGravity = 'NorthEastGravity'
}

export interface WatermarkPosition extends RadioButton {
    copy: string;
    id: string;
}

export const watermarkPositions: WatermarkPosition[] = [
  {
    copy: bfTranslate('Bottom Left'),
    id: (WatermarkPositionsEnum.SouthWestGravity as unknown) as string
  },
  {
    copy: bfTranslate('Top Left'),
    id: (WatermarkPositionsEnum.NorthWestGravity as unknown) as string
  },
  {
    copy: bfTranslate('Bottom Right'),
    id: (WatermarkPositionsEnum.SouthEastGravity as unknown) as string
  },
  {
    copy: bfTranslate('Top Right'),
    id: (WatermarkPositionsEnum.NorthEastGravity as unknown) as string
  }
];

export const defaultWatermarkPostion = watermarkPositions[0].id;
